var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 124,
  height: 54,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  filter: "url(#trending_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C00",
  d: "M26 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7.941h60V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7.941h14a4 4 0 0 1 4 4V38a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V16.941a4 4 0 0 1 4-4h14zm-2 7.941h2v4.47h6v-4.47h2v4.47c0 1.235-.895 2.236-2 2.236h-6c-1.105 0-2-1-2-2.235zm66 0h2v4.47h6v-4.47h2v4.47c0 1.235-.895 2.236-2 2.236h-6c-1.105 0-2-1-2-2.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m22.087 32.467-3.762 2.71 1.415-4.415-3.74-2.74 4.636-.019 1.45-4.403 1.45 4.403 4.637.019-3.74 2.74 1.415 4.415z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "trending_svg__a",
  width: 124,
  height: 54,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5310_1834"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5310_1834",
  result: "shape"
})))));
export default SvgTrending;